// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_JoURR","clearfix":"reset_clearfix_hmiic"};